module.exports = __webpack_public_path__ + "img/chapter2.ecc3875b.png";